import { render, staticRenderFns } from "./form-ficha-emergencia.vue?vue&type=template&id=1a33ad34&"
import script from "./form-ficha-emergencia.vue?vue&type=script&lang=js&"
export * from "./form-ficha-emergencia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports